function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import P from '@leverege/promise';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import { Dialog, Toast } from '@leverege/ui-elements';
import { Plugins, Context } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import FotaItemEditor from "./itemEditor/FotaItemEditor.js";
import { Types } from "../constants/index.js";
const isError = res => res instanceof Error || res?.status >= 300 || res?.status < 200;
export default function ReleaseFirmwareToDeviceGroups(props) {
  const {
    onClose,
    show,
    targets,
    reloadData
  } = props;
  const deviceGroupsAttr = Attributes.getAttribute('deviceGroups', Types.firmwareRelease);
  const target = {
    type: Types.firmwareRelease,
    data: {}
  };
  const deviceGroups = targets.map(tgt => deviceGroupsAttr.source.createOptions.editorProps.toItemValue(tgt?.data));
  target.data = deviceGroupsAttr.set(target.data, deviceGroups);
  const editorProps = {
    title: 'Release Firmware',
    reloadData,
    target,
    mode: 'create',
    attributeOptionKey: 'createOptions',
    submitFormat: 'put',
    objectType: Types.firmwareRelease,
    model: {
      editors: {
        deviceGroups: {
          props: {
            displayOnly: true
          }
        }
      }
    },
    onCancel: onClose,
    onSubmit: async ({
      value
    }) => {
      let newItem = value;
      const delegate = DataSources.getDelegate({
        type: Types.firmwareRelease,
        ref: '/firmwareRelease'
      });
      const plgs = Plugins.get('ItemCreateHook', m => {
        return Context.isMatch({
          objectType: Types.firmwareRelease,
          path: delegate.relationship.path
        }, m);
      });
      for (let n = 0; n < plgs.length; n++) {
        // eslint-disable-next-line no-await-in-loop
        newItem = await plgs[n].hook(newItem, {
          delegate,
          relationship: delegate.relationship
        });
      }
      const deviceGroups = deviceGroupsAttr.get(newItem);
      // get root level firmware release actions
      try {
        const results = await P.mapLimit(deviceGroups, async deviceGroup => {
          const newValue = deviceGroupsAttr.set(newItem, [deviceGroup]);
          return GlobalState.dispatch(delegate.create(newValue, {
            force: true
          }));
        }, {
          handleReject: true,
          limit: 5
        });
        if (results.every(isError)) {
          Toast.error(['All Firmware Releases Failed']);
        } else if (results.find(isError)) {
          const failed = results.reduce((failed, result) => {
            if (isError(result)) {
              return failed + 1;
            }
            return failed;
          }, 0);
          Toast.warn([`${failed} of ${results.length} Firmware Releases Failed`]);
        } else {
          Toast.success(['All Firmware Releases Successful']);
        }
      } catch (err) {
        console.log(err);
        Toast.error(['All Firmware Releases Failed', err.message]);
      }
      reloadData();
      onClose();
    }
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    onClose: onClose,
    show: show
  }, /*#__PURE__*/React.createElement(FotaItemEditor, _extends({}, props, editorProps)));
}